import axios from 'axios'

// initial state
const state = () => ({
  currentStory: []
})

const stories_list = []

// getters
const getters = {}

// actions
const actions = {
  getCurrentStory ({ commit }, story) {
    let currentStory = {}

    if(stories_list[story.lang] === undefined || stories_list[story.lang][story.path] === undefined) {
      axios
        .get(`/_visiones_coronavirus/${story.lang}/${story.path}.json`)
        .then(response => {
          currentStory = response.data
          stories_list[story.lang] = {}
          stories_list[story.lang][story.path] = currentStory
          commit('setCurrentStory', currentStory)
        })
    }
  }
}

// mutations
const mutations = {
  setCurrentStory(state, currentStory){
    state.currentStory = currentStory
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}